import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer'
import './about.css'

const About = (props) => {
  return (
    <div className="about-container">
      <Helmet>
        <title>About - BharatKarade</title>
        <meta
          name="description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta property="og:title" content="About - BharatKarade" />
        <meta
          property="og:description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/37270ff6-c20f-4c60-89cf-ed199b10be0f/dec54fbc-2bef-42e2-a2f0-7c793b6d3599?org_if_sml=1"
        />
      </Helmet>
      <section className="about-container01">
        <Header rootClassName="header-root-class-name2"></Header>
        <section className="about-container02 Fade_in_up1">
          <div className="about-bharat">
            <div className="about-container03">
              <div className="about-container04">
                <img
                  alt="image"
                  src="/playground_assets/og%20image1-1500w.png"
                  className="about-image Fade_in"
                />
              </div>
              <div className="about-container05 Fade_in">
                <span className="about-text">HI, I&apos;m Bharat</span>
                <span className="about-text01">
                  <span>
                    Over 11+ years of experience in Game industry 2D in-depth
                  </span>
                  <br className="about-text03"></br>
                  <br></br>
                  <span>
                    knowledge in drawing and multimedia applications, with a
                    demonstrated history of working in various
                  </span>
                  <br className="about-text06"></br>
                  <br></br>
                  <span>
                    gaming projects. Skilled in 2D Concept, Logo Design, Visual
                    marketing ads. I seek to have a challenging
                  </span>
                  <br className="about-text09"></br>
                  <br></br>
                  <span>
                    position that expertise my skills and enhances my potential
                    to the fullest, also adding my contribution to
                  </span>
                  <br className="about-text12"></br>
                  <br></br>
                  <span>the betterment of the company.</span>
                </span>
              </div>
            </div>
          </div>
          <div className="about-certificates">
            <span className="about-text15">MY CERTIFICATES</span>
          </div>
          <div className="about-bharat1">
            <div className="about-container06">
              <div className="about-container07 Fade_in">
                <span className="about-text16">
                  Certificate Of Appreciation
                </span>
                <span className="about-text17">
                  A certificate for appreciation by webmobril company for
                  working dedicately and delivering project on time.
                </span>
              </div>
              <div className="about-container08">
                <img
                  alt="image"
                  src="/playground_assets/c1-1500w.png"
                  className="about-image1 Fade_in"
                />
              </div>
            </div>
          </div>
          <div className="about-bharat2">
            <div className="about-container09">
              <div className="about-container10">
                <img
                  alt="image"
                  src="/playground_assets/c2-1500w.jpg"
                  className="about-image2 Fade_in"
                />
              </div>
              <div className="about-container11 Fade_in">
                <span className="about-text18">Certificate Of ZVKY Design</span>
                <span className="about-text19">
                  Certificate for 5 years dedicately working for ZVKY design
                </span>
              </div>
            </div>
          </div>
          <div className="about-bharat3">
            <div className="about-container12">
              <div className="about-container13 Fade_in">
                <span className="about-text20">Certificate Of ZVKY Design</span>
                <span className="about-text21">
                  Certificate for 5 years dedicately working for ZVKY design
                </span>
              </div>
              <div className="about-container14">
                <img
                  alt="image"
                  src="/playground_assets/c2-1500w.jpg"
                  className="about-image3 Fade_in"
                />
              </div>
            </div>
          </div>
          <div className="about-certificates1">
            <span className="about-text22">SERVICE SESSION</span>
          </div>
          <div className="about-container15">
            <img
              src="/playground_assets/service-1500w.jpg"
              alt="image"
              className="about-image4"
            />
            <span className="about-text23">2.5D art training session</span>
          </div>
        </section>
        <Footer rootClassName="footer-root-class-name2"></Footer>
      </section>
    </div>
  )
}

export default About
